import React from "react";
import { PeakStateWarmup } from "./PeakState";

const PEAK_HERO_IMG =
  "https://customer-assets.emergentagent.com/job_ecstatic-wilson-4/artifacts/fllwdx32_UfiTk-JtUmSeCnF4.png";
const PEAK_INTAKE_URL = "https://integratedwellness.jotform.com/261513760940051";

const POINTS = [
  "Guided breathing + vivid mental rehearsal, coached step by step.",
  "Optional in-house brain-activity (EEG) wellness session.",
  "Short 5–15 minute sessions, personalized to your goal.",
];

// Compact teaser — replaces the former full inline Peak State landing
// section to keep the homepage a single, scannable scroll.
export default function PeakStateTeaser() {
  return (
    <section id="peak-state" className="mt-24 fade-up" data-testid="peak-state-section">
      <div className="iw-section-head">
        <div className="iw-section-head__label">§ 10 — Peak State · Sibling Program</div>
        <h2 className="iw-section-head__title">Train the state before the shot.</h2>
        <p className="text-base sm:text-lg max-w-3xl" style={{ color: "var(--iw-body)" }}>
          Peak State is our guided focus and mental-rehearsal program — calm, alert, and
          focused on demand. Same wellness-only lane, different goal: performance.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 items-stretch">
        <figure
          className="relative overflow-hidden m-0"
          style={{
            background: "linear-gradient(160deg, #11296b 0%, #1e3a8a 100%)",
            border: "1px solid var(--iw-border)",
            borderRadius: "2px",
            minHeight: 280,
          }}
          data-testid="peak-state-hero-visual"
        >
          <img
            src={PEAK_HERO_IMG}
            alt="Athlete in motion with the body's energy pathways and brain illuminated — the calm, alert, focused state Peak State trains"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <span
            className="absolute top-3 left-3 iw-mono uppercase px-2 py-1"
            style={{
              background: "rgba(17,41,107,0.85)",
              color: "#fff",
              fontSize: "9px",
              letterSpacing: "0.20em",
              borderRadius: "2px",
            }}
          >
            Calm · Alert · Focused
          </span>
          <figcaption
            className="absolute bottom-3 left-4 iw-mono uppercase"
            style={{ color: "rgba(255,255,255,0.88)", fontSize: "10px", letterSpacing: "0.22em" }}
          >
            Wellness · Non-Medical
          </figcaption>
        </figure>

        <div className="iw-card p-6 sm:p-8 flex flex-col" data-testid="peak-state-teaser-card">
          <ul className="space-y-4 m-0 p-0 list-none flex-1">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span
                  className="iw-mono flex-shrink-0 mt-0.5"
                  style={{ color: "var(--iw-accent-red)", fontWeight: 700 }}
                  aria-hidden="true"
                >
                  ✓
                </span>
                <span className="text-[15px] leading-relaxed" style={{ color: "var(--iw-body)" }}>
                  {p}
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex items-center gap-3 flex-wrap">
            <a
              href={PEAK_INTAKE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="iw-btn-primary"
              data-testid="peak-state-intake-btn"
            >
              Start with the intake form <span aria-hidden="true">↗</span>
            </a>
          </div>
          <p
            className="iw-mono uppercase mt-4 m-0"
            style={{ color: "var(--iw-muted)", fontSize: "10px", letterSpacing: "0.20em", fontWeight: 600 }}
          >
            Does not diagnose or treat any condition
          </p>
        </div>
      </div>

      {/* GPT-powered warm-up — kept from the full section */}
      <div className="mt-6">
        <PeakStateWarmup />
      </div>
    </section>
  );
}
